import { render, staticRenderFns } from "./likeEvent.vue?vue&type=template&id=72d32fd0&"
import script from "./likeEvent.vue?vue&type=script&lang=js&"
export * from "./likeEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports